import React, {Component} from "react"
import {Col} from "react-bootstrap"
import classNames from "classnames"

import ValidationInput, {ValidationProps} from "@irati/utils/validation/Input"

import ErrorText from "../ErrorText"

interface Props extends ValidationProps<string> {
  className?: string,
  value?: string
}

interface State {
  errorMsg: string | null,
  value?: string
}

export class FormItemFormError extends Component<Props, State> {
  static defaultProps: Pick<Props, "className"> = {
    className: ""
  }

  validation: ValidationInput

  constructor(props: Props) {
    super(props)
    this.state = {
      errorMsg: null,
      value: props.value
    }

    this.validation = new ValidationInput(this)
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    this.validation.update(prevProps, prevState)
  }

  componentWillUnmount() {
    this.validation.destroy()
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.setState({value: nextProps.value})
  }

  render() {
    const {errorMsg} = this.state
    const className = classNames("perkboxFormError", this.props.className)

    return (
      <Col xs={12} className={className}>
        {errorMsg && (
          <ErrorText small>{errorMsg}</ErrorText>
        )}
      </Col>
    )
  }
}

export default FormItemFormError
